import script from "./UpdateForecastForReceiptModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdateForecastForReceiptModal.vue?vue&type=script&lang=ts&setup=true"

import "./UpdateForecastForReceiptModal.vue?vue&type=style&index=0&id=35395a3e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35395a3e"]])

export default __exports__